export enum PoiListScope {
	All = 'all',
	Shop = 'shop',
	Dine = 'dining',
	Amenity = 'amenity',
}

export const scopeLabels = [
	{ scope: PoiListScope.All, label: 'Show all' },
	{ scope: PoiListScope.Shop, label: 'Shop' },
	{ scope: PoiListScope.Dine, label: 'Dine' },
	{ scope: PoiListScope.Amenity, label: 'Amenity' },
];
